import React, {useMemo} from "react";
import "./messages.css"
import MessagesLog from "./MessagesLog";
import Page from "../../components/page/Page";
import SkeletonItem from "../../components/skeleton/SkeletonItem";
import useAppContext from "../../hooks/useAppContext";
import {LineChart} from "../../components/charts/base/LineChart";
import {getFriendlyDate} from "../../utils/friendlyDate";
import {CHART_COLORS} from "../../components/charts/consts/COLOR_SETS";

const Messages = () => {
    const { data: { lastDaysMessages } } = useAppContext();

    const labels = lastDaysMessages.data?.map((row: any) => getFriendlyDate(new Date(row.days)));
    const dataSets = [
        { label: 'Messages Converted', values: lastDaysMessages.data.map((ldm: any) => ldm.total_orders), backgroundColor: CHART_COLORS[5].solid, borderColor: CHART_COLORS[5].transparent },
        { label: 'Messages Clicked', values: lastDaysMessages.data.map((ldm: any) => ldm.total_clicks), backgroundColor: CHART_COLORS[2].transparent, borderColor: CHART_COLORS[2].transparent },
        { label: 'Messages Read', values: lastDaysMessages.data.map((ldm: any) => ldm.total_read), backgroundColor: CHART_COLORS[1].transparent, borderColor: CHART_COLORS[1].transparent },
        { label: 'Messages Delivered', values: lastDaysMessages.data.map((ldm: any) => ldm.total_delivered), backgroundColor: CHART_COLORS[3].transparent, borderColor: CHART_COLORS[3].transparent },
        { label: 'Messages Sent', values: lastDaysMessages.data.map((ldm: any) => ldm.total_sent), backgroundColor: CHART_COLORS[0].transparent, borderColor: CHART_COLORS[0].transparent },
        { label: 'Messages Failed', values: lastDaysMessages.data.map((ldm: any) => ldm.total_failed), backgroundColor: CHART_COLORS[4].transparent, borderColor: CHART_COLORS[4].transparent },
    ];
    const totalMessagesSent = lastDaysMessages.data.reduce((acc: number, row: any) => acc + parseInt(row.total_sent), 0);
    const totalMessagesConverted = lastDaysMessages.data.reduce((acc: number, row: any) => acc + parseInt(row.total_orders), 0);

    return <Page
        className="messages-page-container"
        title="Messages"
        subtitle="Track every message sent through your shop’s automations, events, and campaigns."
    >
        <div className="messages-charts-layout">
            <div className="messages-charts-item grid-8">{lastDaysMessages.isLoading ? <SkeletonItem height={200} gridSpan={8} /> :
                <LineChart
                    data={lastDaysMessages.data}
                    labels={labels}
                    dataSets={dataSets}
                    isDataLoaded={lastDaysMessages.isLoaded}
                />
            }</div>
            <div className="messages-charts-item grid-4">
                {lastDaysMessages.isLoading ? <SkeletonItem height={200} gridSpan={4} /> :
                    <div className="weekly-summary">
                        <div className="total-sent"><div>{totalMessagesSent}</div><span>Messages Sent <span>(Last 7 Days)</span></span></div>
                        <div className="total-converted"><div>{totalMessagesConverted}</div><span>Messages Converted <span>(Last 7 Days)</span></span></div>
                    </div>
                }
            </div>
        </div>
        <MessagesLog />
    </Page>
}

export default Messages;